package team.platforma.multiplatform_material_extension.ui.core.global_style

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonColors
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.dp

object ExtraFabStyle {
    var shape: Shape? = null
    var fabColorScheme: FilledButtonColorScheme? = null
}

@Composable
internal fun takeGlobalFabShape(): Shape {
    val global = ExtraFabStyle.shape
    val default = RoundedCornerShape(16.dp)
    return global ?: default
}

@Composable
internal fun takeGlobalFabButtonColors(): ButtonColors {
    return takeFiledButtonColors().define(ExtraFabStyle.fabColorScheme)
}

@Composable
private fun ButtonColors.define(
    global: FilledButtonColorScheme?,
): ButtonColors {
    return this.copy(
        containerColor = global?.containerColor ?: this.containerColor,
        contentColor = global?.contentColor ?: this.contentColor,
        disabledContainerColor = global?.disabledContainerColor ?: this.disabledContainerColor,
        disabledContentColor = global?.disabledContentColor ?: this.disabledContentColor
    )
}